
interface ProductContentProps {
  title: string;
  description: string;
  logo: string;
}

export const ProductContent = ({ title, description, logo }: ProductContentProps) => {
  return (
    <>
      {logo && (
        <div className="w-full">
          <img 
            src={logo} 
            alt={`${title} logo`} 
            className="w-full h-48 object-contain"
          />
        </div>
      )}
      <div className="p-6">
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <div 
          className="text-gray-600 mb-4"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </>
  );
};
